export const blockIconsDevicePriceChange = (
	<span className='material-symbols-outlined'>price_change</span>
);
